<script>
import { onMount } from 'svelte';
import Icon from 'svelte-icon';
import arrowThinRight from './zondicons/arrow-thin-right.svg';

export let html;
export let next_href;

onMount(() => {	if (MathJax?.typeset != null) { MathJax.typeset(); }});
</script>

<div class="instructions mathjax">
{@html html}

{#if next_href != null}
<div class="controls">
	<a class="next" href="{next_href}">Next &nbsp;<Icon data={arrowThinRight} size='.7em'/></a>
</div>
{/if}

</div>

<style>
	.instructions {
		padding: 1rem 1.61rem;
		overflow: auto;
		flex: 1;
		height: 0;
		line-height: 1.1;
	}

	.controls {
        margin-top: 1rem;
		border-top: 1px solid rgba(255,255,255,.15);
		padding: 1em 0 0 0;
		display: flex;
	}

	a.next {
		margin-left: auto;
		text-decoration: none;
		border-bottom: solid var(--sidebar-text) 1px;
		transition: color .2s, border .2s;
	}
	a.next:hover {
		border-bottom-color: white;
	}

	.instructions :global(h2) {
		margin: 1.6rem 0 .8rem 0;
		font-size: 1.4rem;
		line-height: 1;
		font-weight: 400;
		color: white;
	}

	.instructions :global(h3) {
		margin: 1.6rem 0 .8rem 0;
		font-size: 1rem;
		line-height: 1;
		font-weight: bold;
		color: white;
	}
	.instructions :global(h3) :global(code) {
		color: white;
		padding: 0em 0.5em;
	}

	.instructions :global(h2:first-child) {
		margin-top: .4rem;
	}

	.instructions :global(a) {
		color: var(--sidebar-text);
	}

	.instructions :global(a:hover) {
		color: white;
	}

	.instructions :global(.q::before) {
		content: "Q";
		color: var(--back-light);
		background-color:var(--text);
		border-radius: .8em;
		margin-right: .3em;
		padding: .2em .3em .2em .2em;
		box-shadow: 1pt 1pt 1pt rgb(0 0 0 / 30%) inset;
	}

	.instructions :global(ul), .instructions :global(ol) {
		padding: 0 0 0 2em;
	}

	.instructions :global(li) {
		margin-bottom: 0.4em;
	}

	.instructions :global(.para) {
		margin-bottom: 1em;
	}

	.instructions :global(.para.test) {
		background-color: yellow;
	}

	.instructions :global(.para) :global(p), .instructions :global(.para) :global(ul) {
		margin-bottom: 0.5em;
		margin-top: 0.5em;
	}
	.instructions :global(blockquote) {
		background-color: var(--sidebar);
		color: var(--sidebar-text);
		padding-left: 1em;
		margin-bottom: 1em;
		border-left: solid var(--third) 1pt;
		font-size: 85%;
	}
	.instructions :global(blockquote) :global(code) {
		color: var(--sidebar-text);
	}

	.instructions::-webkit-scrollbar {
		background-color: var(--second);
		width: 8px;
	}

	.instructions::-webkit-scrollbar-thumb {
		background-color: rgba(255,255,255,.7);
		border-radius: 1em;
	}

	.instructions :global(p) :global(code) {
		color: var(--sidebar-text);
		background: rgba(0,0,0,.06);
		padding: .1em .4em .2em;
		white-space: nowrap;
		position: relative;
		top: -0.0em;
	}

	.instructions :global(pre) {
		background: var(--back-light);
		overflow: auto;
		margin: 0.4rem 0 1.2rem;
		padding: 0.8rem 1rem;
		border-radius: var(--border-r);
		box-shadow: 1px 1px 1px rgb(68 68 68 / 12%) inset;
		text-align: left;
		white-space: pre;
		word-spacing: normal;
		word-break: normal;
		word-wrap: normal;
		font-family: var(--font-mono);
		font-size: 0.9rem;
		color: var(--second);
		tab-size: 2;
		hyphens: none;
	}

	.instructions  :global(code.meta) {
		text-transform: uppercase;
		font-style: italic;
		font-size: 90%;
	}
	.instructions :global(code.long) {
		white-space: normal;
		word-break: break-word;
	}
	.instructions :global(code) :global(code.meta) {
		background-color: transparent;
		padding: 0px;
	}
	.instructions :global(.matrix) {
		margin: 0 auto;
	}
	.instructions :global(.matrix) :global(td) {
		padding: 0.1em 0.5em;
	}
	.instructions :global(.matrix) :global(td.border) {
		padding: 0;
		width: 0.2em;
		border: solid 1pt var(--sidebar-text);
	}
	.instructions :global(.matrix) :global(td.border.left) {
		border-right-width: 0;
	}
	.instructions :global(.matrix) :global(td.border.right) {
		border-left-width: 0;
	}
	.instructions :global(table.data) {
		border-collapse: collapse;
		border: solid var(--back-light);
		border-width: 0.4pt 0 0.8pt 0;
		margin: 0 auto;
	}
	.instructions :global(table.data thead th) {
		border-bottom: solid var(--back-light) 0.4pt;
	}
	.instructions :global(table.data td), .instructions :global(table.data th) {
		padding: 0.1em 0.3em;
	}
</style>
